export const Filter = {
  ALL: { index: 'a', source: 'data.json' },
  PRIMARY: { index: 'p', source: 'data-p.json' },
  SECONDARY: { index: 's', source: 'data-s.json' },
  YOURS: { index: 's', source: 'data-s.json' },
};
